import React from 'react';

import DevicesDashboard from './DevicesDashboard';
const Dashboard = ({role}) => {
  
  return (
     <DevicesDashboard />
  );

};

export default Dashboard;
